module.exports = "/_next/static/chromiums/og-1200x630-products-very-cherry-lip-balm-8d2dd860262faff9c4cfeb09d4295ef6.jpg";